module.exports = __webpack_public_path__ + "static/media/calendar.92ccddf2.svg";